import ErrorBoundary from "@/components/ErrorBoundary";
import Button from "@/components/Button";
import { useNavigate } from "@/router";

export default function PersonNotFoundErrorBoundary() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[60vh] p-6">
      <ErrorBoundary
        title="Person Not Found"
        message="The person you're looking for could not be found. They may not exist or you may not have permission to view their profile."
        image="default"
        variant="fullPage"
        action={
          <Button variant="filled" onClick={() => navigate("/people")} data-testid="return-home-button">
            Return to Home
          </Button>
        }
      />
    </div>
  );
}
